import React from 'react';
import { Specific as SpecificIcon } from 'common/components/svgs';
import { Tooltip } from 'antd';

function TipsBox({ placement, partners }) {
  return (
    <div className="tips-box">
      <SpecificIcon style={{ height: '16px', width: '16px', marginRight: '8px' }} />
      <div>This promotion is for specific partners only.</div>
      <Tooltip
        placement={placement || 'top'}
        title={
          <div>
            {partners?.map((partner, key) => (
              <div key={key}>
                {key + 1}. {partner?.name}
              </div>
            ))}
          </div>
        }
      >
        <div className="link">View Linked Partner</div>
      </Tooltip>
    </div>
  );
}

export default TipsBox;
